import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { LocaleProvider } from '@/i18n/LocaleContext';
import Home from '@/pages/Home';

function App() {
  return (
    <div className="App" data-release="ca-cache-recovery">
      <LocaleProvider>
        <BrowserRouter>
          <Routes>
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-center" richColors />
      </LocaleProvider>
    </div>
  );
}

export default App;
